export const FETCH_USAGELIST_BEGIN = 'FETCH_USAGELIST_BEGIN';
export const FETCH_USAGELIST_SUCCESS = 'FETCH_USAGELIST_SUCCESS';
export const FETCH_USAGELIST_ERROR = 'FETCH_USAGELIST_ERROR';